export function getOptionsDefaults()
{
	return {
		compilerOptions:
		{
			module: "ES2015",
		},
	};
}
